import { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { RetailerPricingTable } from './RetailerPricingTable';
import { CymbioSpinner } from '../../common/Spinner';
import Pagination, { RowsPerPage, PaginationWrapper } from '../../common/Pagination';
import { PricingFilters } from '../../filters/PricingFilters';
import { pricingRowsPerPage } from '../../../constants/pricings';
import {
  exportSupplierRetailerPricing,
  getSupplierRetailerPricing,
  setPricingPage,
  setPricingRowsPerPage,
  uploadSupplierRetailerPricing,
} from '../../../store/actions/pricing';

export function RetailerPricingPage(props) {
  const dispatch = useDispatch();
  const { id: retailerId } = props;
  const {
    isLoading,
    filters,
    totalCount,
    table: { rowsPerPage, page },
  } = useSelector((state) => state.pricings);
  const { pricing_currencies: currencies } = useSelector((state) => state.retailer.current?.retailer ?? {});

  const fetchPricing = useCallback(() => {
    dispatch(getSupplierRetailerPricing(retailerId));
  }, [dispatch, retailerId]);

  useEffect(() => {
    fetchPricing();
  }, [fetchPricing, filters]);

  const setRowsPerPage = (newRowsPerPage) => {
    dispatch(setPricingRowsPerPage(newRowsPerPage));
    fetchPricing();
  };

  const setPage = (newPage) => {
    dispatch(setPricingPage(newPage));
    fetchPricing();
  };

  return (
    <div className="retailer-pricing-page">
      <PricingFilters
        currencies={currencies}
        onExport={exportSupplierRetailerPricing}
        onUpload={(payload) => uploadSupplierRetailerPricing(payload, retailerId)}
      />

      {isLoading ? (
        <CymbioSpinner />
      ) : (
        <>
          <RetailerPricingTable refetch={fetchPricing} />

          <PaginationWrapper>
            <RowsPerPage options={pricingRowsPerPage} current={rowsPerPage} onChange={setRowsPerPage} />
            <Pagination
              pageCount={Math.ceil(totalCount / rowsPerPage)}
              handlePageClick={({ selected }) => setPage(selected)}
              currentPage={page}
            />
          </PaginationWrapper>
        </>
      )}
    </div>
  );
}

RetailerPricingPage.propTypes = {
  id: PropTypes.number.isRequired,
};
